import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { ComponentType, Props } from './';
import './Header.scss';

const Header: ComponentType = ({
  className,
  headerData,
}: Props): ReactElement => (
  <>
    <tr
      className={classNames(
        'VariantsMatrixTable-HeaderRow',
        {
          'VariantsMatrixTable-HeaderRow--First2D': headerData.secondaryTitle,
        },
        className,
      )}
    >
      {headerData.secondaryTitle && <th />}

      <th colSpan={headerData.options.length}>{headerData.title}</th>
    </tr>
    <tr
      className={classNames(
        'VariantsMatrixTable-HeaderRow',
        {
          'VariantsMatrixTable-HeaderRow--Second': !headerData.secondaryTitle,
          'VariantsMatrixTable-HeaderRow--Second2D': headerData.secondaryTitle,
        },
        className,
      )}
    >
      {headerData.secondaryTitle && <th>{headerData.secondaryTitle}</th>}

      {headerData.options.map((option) => (
        <th key={option}>{option}</th>
      ))}
    </tr>
  </>
);

export { Header };
